import { Box } from '@mui/material'
import React from 'react'

const WidgetLoader = () => {
    return (
        <Box display={'flex'} justifyContent={'center'} padding={10}>
            <div class="loader"></div>
        </Box>
    )
}

export default WidgetLoader